import React from 'react';
import {View} from 'react-native';

const ItemSeparator = () => {
  return <View style={{width: 8, height: 8}} />;
};

export default ItemSeparator;
